import { useEffect, useState } from "react";
import { AppBar, Box, Grid, IconButton, Link, Toolbar, Tooltip } from "@mui/material";
import { AppColors } from "../resources/AppColors";
import { ReactComponent as TaglineSVG } from "../img/tagline_icon2_ultra_small.svg";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import DialogMonitoring from "./DialogMonitoring";
import { LabelsLogOut, navBarTooltips } from "../locale/es";
import TextMonitoring from "./TextMonitoring";
import { textType } from "../resources/AppTexts";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DropdownCenterSelector from "./CenterSelectors/DropdownCenterSelector";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "redux/reducers/userAuthenticationReducer";
import { useDispatch, useSelector } from "react-redux";
import { RolesManager } from "utils/RolesManager";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
    fontSize: "0.8rem",
  },
}));

const sections = [
  {
    title: navBarTooltips.CENTERS,
    icon: <AddBusinessIcon />,
    link: "/gestio-dels-centres",
    isSuperAdminRoute: true, // TODO: Change to isSuperAdminRoute and apply logic in Sidebar component
  },
  {
    title: navBarTooltips.PACKAGES,
    icon: <Inventory2OutlinedIcon sx={{ mt: -.3 }} />,
    link: '/paquetes',
    isSuperAdminRoute: true,
  },
  {
    title: navBarTooltips.ORGANIZATIONS,
    icon: <CorporateFareOutlinedIcon sx={{ mt: -.3 }} />,
    link: '/organizaciones',
    isSuperAdminRoute: true,
  },
];

// TODO: Separate Login screen navbar from authenticated screens navbars
const NavbarMonitoring = ({
  logged,
  open,
  handleDrawerOpen,
  handleDrawerClose,
}) => {
  const location = useLocation();

  const [showExitModal, setShowExitModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);

  const { user } = useSelector(state => state.userAuthentication)

  const navigate = useNavigate();

  const dispatch = useDispatch()

  const classes = useStyles();

  useEffect(() => {
    if (location.pathname === "/gestio-dels-centres") setSelectedSection(0);
    else if (location.pathname === "/componentes") setSelectedSection(1);
    else if (location.pathname === "/componentes/configuracion")
      setSelectedSection(1);
    else if (location.pathname === "/componentes/configuracion/formularios")
      setSelectedSection(1);
    else if (location.pathname === "/componentes/configuracion/contenidos")
      setSelectedSection(1);
    else if (location.pathname === "/componentes/configuracion/mensajes")
      setSelectedSection(1);
    else if (location.pathname === "/intervenciones") setSelectedSection(2);
    else if (location.pathname === "/paquetes") setSelectedSection(3);
    else if (location.pathname === "/organizaciones") setSelectedSection(4);
    else setSelectedSection(null);
  }, [location]);

  const handleShowExitModal = () => {
    setShowExitModal(!showExitModal);
  };

  const handleOnConfirmExit = () => {
    dispatch(logout())
    setShowExitModal(false);
  };

  return (
    <AppBar
      style={{
        color: AppColors.WHITE,
        background: AppColors.PRIMARY,
      }}
      position='fixed'
    >
      <Toolbar>
        {/* // ** Handles Sidebar open and close */}
        {logged && (
          <>
            <IconButton
              color={"inherit"}
              aria-label='open drawer'
              edge='start'
              onClick={open ? handleDrawerClose : handleDrawerOpen}
            >
              {!open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
            <DropdownCenterSelector />
          </>
        )}
        <Link
          to={"/home"}
          sx={{ flexGrow: 1, textAlign: "center" }}
          underline='hover'
        >
          <TaglineSVG />
        </Link>
        {logged && (
          <Box sx={{ position: "absolute", right: 10 }}>
            {sections.map((section, i) =>
              RolesManager.userIsSuperAdmin(user.roles) ? ( // ! Sufficient for only having centers management page here. Has to be modified similar to how is handled in Sidebar for integrating interventions and components
                <Tooltip
                key={section.title}
                title={section.title}
                arrow
                placement="bottom"
                classes={{ tooltip: classes.tooltip }}
              >
                <IconButton
                  key={section.title}
                  size='large'
                  color='inherit'
                  onClick={() => navigate(section.link)}
                  sx={{
                    mx: -0.5,
                    bgcolor: selectedSection === i ? "#0000003d" : "",
                  }}
                >
                  {section.icon}
                </IconButton>
                </Tooltip>
              ) : null
            )}
            <IconButton
              onClick={handleShowExitModal}
              color='inherit'
              size='large'
              sx={{ ml: 10 }}
              data-cy='logout-button'
            >
              <ExitToAppIcon />
            </IconButton>
          </Box>
        )}
        {showExitModal && (
          <DialogMonitoring
            textCancelButton={LabelsLogOut.CANCEL}
            title={LabelsLogOut.LOG_OUT}
            textConfirmButton={LabelsLogOut.SURE}
            buttonColor={AppColors.RED}
            show={showExitModal}
            handleShow={handleShowExitModal}
            handleConfirm={handleOnConfirmExit}
          >
            <Grid>
              <TextMonitoring
                color={AppColors.PRIMARY}
                type={textType.BODY}
                text={LabelsLogOut.TEXT}
              />
            </Grid>
          </DialogMonitoring>
        )}
      </Toolbar>
    </AppBar>
  );
};
NavbarMonitoring.propTypes = {};

export default NavbarMonitoring;
